import { store } from '@/index';
import { setCurrentProjectId, updateEmailConfirmModal } from '@/actions';

export const fetchAPI = async (path, token, params, options = {}) => {
    const response = await fetch(`${process.env.REACT_APP_API_URL}${path}`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
            accessToken: token,
            ...params
        }),
        ...options,
    });

    if (!response.ok) {
        const errorData = await response.json();
        const error = new Error(errorData.message || 'HTTP error');
        error.response = errorData;
        error.status = response.status;

        if (response.status === 401) {
            store.dispatch(setCurrentProjectId(null));
            window.location.href = "/select_project";
        } else if (store.getState().auth?.user && response.status === 412) {
	        store.dispatch(updateEmailConfirmModal(true));
        }

        throw error;
    }

    return response;
};

export const fetchFormDataAPI = async (path, token, params, options = {}) => {
    params.append('accessToken', token);

    const response = await fetch(`${process.env.REACT_APP_API_URL}${path}`, {
        method: "POST",
        body: params,
        ...options,
    });

    if (!response.ok) {
        const errorData = await response.json();
        const error = new Error(errorData.message || 'HTTP error');
        error.response = errorData;
        error.status = response.status;

        if (store.getState().auth?.user && response.status === 412) {
            store.dispatch(updateEmailConfirmModal(true));
        }

        throw error;
    }

    return response;
};
